// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const experimentsClient = createTypedClient();
export const createExperimentsClient = (config) => createTypedClient(config);
